import { FormatInt } from '../../utils/format';
import { MONO_CLASS } from './Mono';

/**
 * Chip de filtro (pílula com `aria-pressed`) — o visual dos chips de área de
 * Localizações, com contagem opcional em monoespaçada ao lado do rótulo.
 */
const FilterChip = ({ active = false, count = null, onClick, children, title, disabled = false }) => (
    <button
        type="button"
        onClick={onClick}
        aria-pressed={active}
        title={title}
        disabled={disabled}
        className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${
            active
                ? 'border-transparent bg-black font-medium text-white dark:bg-white dark:text-black'
                : 'border-mono-300 text-mono-700 hover:bg-mono-50 dark:border-mono-700 dark:text-mono-300 dark:hover:bg-mono-900'
        }`}
    >
        <span>{children}</span>
        {count !== null && count !== undefined ? (
            <span
                className={`${MONO_CLASS} text-xs ${
                    active ? 'text-mono-300 dark:text-mono-600' : 'text-mono-500 dark:text-mono-400'
                }`}
            >
                {FormatInt(count)}
            </span>
        ) : null}
    </button>
);

export default FilterChip;
